import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { CommonConstant } from '@utility/constants/common';
import CatalogService from '@utility/services/catalog';
import { useState } from 'react';
import { catalogKeys } from '../lib/query-keys';

export type ScmReport = {
  _id: string;
  type: string;
  status?: string;
  url?: string;
  createdAt?: string;
};

const NO_REPORTS: ScmReport[] = [];
const SHEETS = ['purchase-order-sheet', 'shipment-sheet', 'inventory-sheet'];

/** Exported SCM sheets of every kind, a page at a time; only while `enabled`. */
export function useScmReports(enabled: boolean) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState<number>(CommonConstant.defaultPageSize);
  const params = { page, limit };

  const query = useQuery({
    queryKey: catalogKeys.scmReports(params),
    queryFn: async () => {
      const result = await CatalogService.getSCMReportList(params);
      return {
        reports: SHEETS.flatMap(
          sheet => (result?.data?.[sheet] ?? []) as ScmReport[],
        ),
        total: (result?.totalCount ?? 0) as number,
      };
    },
    enabled,
    placeholderData: keepPreviousData,
  });

  return {
    reports: query.data?.reports ?? NO_REPORTS,
    total: query.data?.total ?? 0,
    loading: query.isFetching,
    page,
    limit,
    setPage,
    setLimit: (size: number) => {
      setLimit(size);
      setPage(1);
    },
    refresh: () => void query.refetch(),
  };
}
